module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/085-solomon-islands-f7da641196be4579ebd1ed3179552d5b.svg";